import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcnContact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28.208723,
	height: 28.2749,
	viewBox: "0 0 28.208723 28.2749",
	id: "svg1",
	"sodipodi:docname": "icn-contact.svg",
	"inkscape:version": "1.3.2 (091e20e, 2023-11-25)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs1" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview1",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			"inkscape:zoom": 4.9166667,
			"inkscape:cx": 14.135593,
			"inkscape:cy": 14.033898,
			"inkscape:window-width": 1312,
			"inkscape:window-height": 449,
			"inkscape:window-x": 0,
			"inkscape:window-y": 38,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "svg1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m 17.213785,6.7649 0.078,0.081 c -0.0234,-0.0304 -0.0499,-0.0584 -0.078,-0.081 z m -7.3870001,21.51 c -2.8785,0 -5.6745,-1.0258 -7.6831,-3.043 L 0.95578494,24.0447 c -0.6111,-0.6126 -0.97668,-1.6072 -0.95486000053,-2.601 C 0.02353494,20.4327 0.43198494,19.5129 1.1537849,18.8535 l 3.9635,-3.9674 c 0.9619,-0.9385 2.6541,-1.23 3.9293,0.0421 l 1.1817001,1.184 5.5817,-5.588 -1.0546,-1.0944 c -0.5028,-0.3952 -0.8816,-1.1294 -0.9128,-1.9213 -0.0483,-1.283 0.8348,-2.1919 1.0118,-2.361 l 4.2777,-4.28079997 c 1.1582,-1.15598 3.0391,-1.15442 4.1942,-0.0024 L 24.917185,2.4583 c 2.1771,2.1763 3.3751,5.2061 3.287,8.3106 -0.0865,2.983 -1.3609,5.7868 -3.5005,7.6949 l -0.3001,0.304 c -0.7094,0.7101 -1.8591,0.7101 -2.5676,0 -0.7093,-0.7093 -0.7093,-1.8583 0,-2.5676 l 0.3757,-0.3757 c 1.4716,-1.3173 2.3049,-3.1716 2.3618,-5.16 0.0608,-2.1092 -0.7491,-4.167 -2.2238,-5.6394 l -1.1201,-1.1224 -3.4452,3.4483 1.0632,1.0913 c 0.7802,0.8075 0.9213,1.6415 0.9002,2.2004 -0.0405,1.1263 -0.7358,1.8333 -0.9486,2.0235 l -6.4446,6.4523 c -0.2751,0.343 -1.0211,0.8559 -1.958,0.8995 -0.6189001,0.0156 -1.5246001,-0.1278 -2.4381001,-1.0398 l -0.898,-0.8979 -3.3976,3.3984 1.0507,1.1864 c 2.4997,2.5083 7.0868001,2.6463 10.2265001,0.3126 l 1.1957,-0.9814 c 0.7717,-0.6423 1.9206,-0.5246 2.5559,0.2448 0.6376,0.7755 0.5276,1.9198 -0.2456,2.5566 l -1.2767,1.046 c -2.1895,1.6299 -4.7984,2.4312 -7.3426001,2.4312 z",
			id: "path1"
		})
	]
});
export default SvgIcnContact;
